var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 14.75,
    fill: "#E5E9F2",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.523 9.19033C10.1472 8.81449 9.56616 8.81449 9.19033 9.19033C8.81449 9.56616 8.81449 10.1472 9.19033 10.523L13.7757 15.1084L9.19033 19.6939C8.81449 20.0697 8.81449 20.6507 9.19033 21.0266C9.27021 21.1064 9.36458 21.1809 9.48244 21.2332C9.60189 21.2863 9.7266 21.3084 9.85668 21.3084C9.98677 21.3084 10.1115 21.2863 10.2309 21.2332C10.3488 21.1809 10.4432 21.1064 10.523 21.0266L15.1084 16.4412L19.6939 21.0266C19.8834 21.2161 20.1533 21.3084 20.3602 21.3084C20.5671 21.3084 20.837 21.2161 21.0266 21.0266C21.4024 20.6507 21.4024 20.0697 21.0266 19.6939L16.4412 15.1084L21.0266 10.523C21.4024 10.1472 21.4024 9.56616 21.0266 9.19033C20.6507 8.81449 20.0697 8.81449 19.6939 9.19033L15.1084 13.7757L10.523 9.19033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.52aea883.svg";
export { ForwardRef as ReactComponent };